import { render, staticRenderFns } from "./ConsultarPage.vue?vue&type=template&id=92dd9f42&scoped=true&"
import script from "./ConsultarPage.vue?vue&type=script&lang=js&"
export * from "./ConsultarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dd9f42",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/doctos-oficiales/ConsultarPage.vue
// module id = 201
// module chunks = 21